<template>
  <div class="Assets-analysis">
    <div class="Title">
      <span>资产分析</span>
      <div>
        <el-button type="primary">生成报告</el-button>
        <el-button type="primary">查看历史</el-button>
        <el-button type="primary">加入待办</el-button>
      </div>
    </div>
    <el-row class="personal-data-one">
      <el-col :span="8">
        <div class="oneself">
          <span class="name">{{customerDataRow.custName}}</span>
          <span><img src="@/assets/images/wpsp/Customer-view/钻石.png"
                 alt=""></span>
          <span><img src="@/assets/images/wpsp/Customer-view/男.png"
                 alt=""
                 v-if="customerDataRow.gender==='1'">
            <img src="@/assets/images/wpsp/Customer-view/女.png"
                 alt=""
                 v-else></span>
          <span>{{customerDataRow.age}}岁</span>
          <span>{{customerDataRow.customerLevel}}</span>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="member">
          <span style="color:rgba(144,147,153,1);">家庭成员：</span>
          <span>
            <span v-for="(v,i) in memberOfFamily"
                  :key="i">{{v.custRelation|familyRelationship}}-{{v.custName}}<span v-if="i!==memberOfFamily.length-1">、</span></span>
          </span>
        </div>
      </el-col>
    </el-row>
    <el-row class="personal-data-two">
      <el-col :span="8">
        <div class="Telephone">
          <span>手机号码：</span>
          <span>{{customerDataRow.mobileNumber|encryptPhone}}</span>
          <span><img src="@/assets/images/wpsp/Customer-view/短信.png"
                 alt=""></span>
          <span><img src="@/assets/images/wpsp/Customer-view/电话.png"
                 alt=""></span>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="Features">
          <span style="color:rgba(144,147,153,1);font-size:14px;">金融特征：</span>
          <span class="Label">
            <span>资产规模</span>
            <span>资产规模</span>
            <span>资产规模</span>
            <span>资产规模</span>
            <span>资产规模</span>
          </span>
        </div>
      </el-col>
    </el-row>
    <!-- 财务分析 -->
    <div class="financial-analysis">
      <!-- 完善财务信息 -->
      <el-dialog title="完善财务信息"
                 :visible.sync="dialogVisible"
                 width="65%"
                 :before-close="handleClose">
        <div class="perfectFinance">
          <el-tabs v-model="activeName"
                   @tab-click="handleClick">
            <el-tab-pane label="资产负债"
                         name="Finance">
              <!-- 资产负债 -->
              <div class="Finance">
                <div class="top">
                  <div>
                    <!-- <span class="Tips">注：资产负债的弹窗固定高度，列表显示不下</span> -->
                  </div>
                </div>
                <div class="bottom">
                  <el-tabs v-model="activeNameTwo"
                           type="card">
                    <el-tab-pane label="本人"
                                 name="oneself"
                                 :disabled='!LiabilitiesEditShow'>
                      <financialInformationEdit ref="LiabilitiesOne"
                                                cis='300000000012'
                                                custRelationship='0'
                                                v-if="activeNameTwo==='oneself'"
                                                @ModificationFailed="ModificationFailed"></financialInformationEdit>
                    </el-tab-pane>
                    <el-tab-pane label="配偶"
                                 name="spouse"
                                 :disabled='!LiabilitiesEditShow'>
                      <financialInformationEdit ref="LiabilitiesTwo"
                                                cis='300000000012'
                                                custRelationship='1'
                                                v-if="activeNameTwo==='spouse'"
                                                @ModificationFailed="ModificationFailed"></financialInformationEdit>
                    </el-tab-pane>
                    <el-tab-pane label="总计"
                                 name="total"
                                 :disabled='!LiabilitiesEditShow'>
                      <financialInformationEdit ref="LiabilitiesThree"
                                                cis='300000000012'
                                                custRelationship='2'
                                                v-if="activeNameTwo==='total'"
                                                @ModificationFailed="ModificationFailed"></financialInformationEdit>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="收入支出"
                         name="personal">
              <IncomeAndExpenditureEdit ref="incomeAndExpenditure"
                                        cis='300000000012'
                                        :incomeExpenditure="incomeExpenditure"></IncomeAndExpenditureEdit>
            </el-tab-pane>
          </el-tabs>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary"
                     @click="financialInformationPreservation(true)"
                     v-if="activeName==='Finance'">保 存</el-button>
          <el-button type="primary"
                     @click=" incomeAndExpenditurePreservation"
                     v-if="activeName==='personal'">保 存</el-button>
        </span>
      </el-dialog>
      <div class="financial-analysis-top">
        <span class="top-left">财务分析</span>
        <el-button type="text"
                   icon="el-icon-edit-outline"
                   @click="dialogVisible = true,activeName='Finance'">完善财务信息</el-button>
      </div>
      <div class="financial-analysis-bottom">
        <div class="bottom-left">
          <div>
            <img src="@/assets/images/wpsp/Customer-view/tanhao.png"
                 alt=""
                 v-if="indexAnalysisList.expendStructure.incomeStructMark!=='0'">
            <img src="@/assets/images/wpsp/Customer-view/dui.png"
                 alt=""
                 v-else>
            <span class="text">{{indexAnalysisList.expendStructure.expendStructure0}}</span>
            <div>
              {{indexAnalysisList.expendStructure.expendStructure1}}
            </div>
          </div>
          <div>
            <img src="@/assets/images/wpsp/Customer-view/tanhao.png"
                 alt=""
                 v-if="indexAnalysisList.debtStructure.incomeStructMark!=='0'">
            <img src="@/assets/images/wpsp/Customer-view/dui.png"
                 alt=""
                 v-else>
            <span class="text">{{indexAnalysisList.debtStructure.debtStructure0}}</span>
            <div>
              {{indexAnalysisList.debtStructure.debtStructure1}}
            </div>
          </div>
          <div>
            <img src="@/assets/images/wpsp/Customer-view/tanhao.png"
                 alt=""
                 v-if="indexAnalysisList.financeFlowStructure.incomeStructMark!=='0'">
            <img src="@/assets/images/wpsp/Customer-view/dui.png"
                 alt=""
                 v-else>
            <span class="text">
              {{indexAnalysisList.financeFlowStructure.financeFlowStructure0}}</span>
            <div>
              {{indexAnalysisList.financeFlowStructure.financeFlowStructure1}}
            </div>
          </div>
          <div>
            <img src="@/assets/images/wpsp/Customer-view/tanhao.png"
                 alt=""
                 v-if="indexAnalysisList.incomeStructure.incomeStructMark!=='0'">
            <img src="@/assets/images/wpsp/Customer-view/dui.png"
                 alt=""
                 v-else>
            <span class="text">{{indexAnalysisList.incomeStructure.incomeStruct0}}</span>
            <div>
              {{indexAnalysisList.incomeStructure.incomeStruct1}}
            </div>
          </div>
        </div>
        <div class="bottom-right">
          <span class="text">家庭年收入
            <span>{{FamilyIncome.incomeOfYear}}元</span>，家庭年支出
            <span>{{FamilyIncome.expendOfYear}}元</span> ，年结余率 {{FamilyIncome.arob}}%.</span>
          <div class="chart">
            <v-chart :options="incomeOptions"
                     style="width:450px;height: 300px;"></v-chart>
            <v-chart :options="expenditureOptions"
                     style="width:450px;height: 300px;"></v-chart>
          </div>
        </div>
      </div>
    </div>
    <!-- 资产检视 -->
    <div class="assets-inspection">
      <div class="assets-inspection-top">
        <span class="top-left">资产检视</span>
        <el-button type="text">查看完整配置<i class="el-icon-arrow-right"></i></el-button>
      </div>
      <div class="assets-inspection-bottom">
        <div class="bottom-left">
          <span class="text">客户风险等级：平衡型</span>
          <div class="risk-level">
            <span>保守型<img src="@/assets/images/wpsp/Customer-view/dangqian.png"
                   alt=""> </span>
            <span>谨慎型<img src="@/assets/images/wpsp/Customer-view/dangqian.png"
                   alt=""></span>
            <span>平衡型<img src="@/assets/images/wpsp/Customer-view/dangqian.png"
                   alt=""></span>
            <span>进取型<img src="@/assets/images/wpsp/Customer-view/dangqian.png"
                   alt=""></span>
            <span>激进型<img src="@/assets/images/wpsp/Customer-view/dangqian.png"
                   alt=""></span>
          </div>
          <div class="explain-text">
            作为<span>稳健型</span>的客户，基本上接受低程度的损失，以换取低程度的潜在投资回报。可能适合您的产品之资本价值可能波动并跌至低于您原本的投资额。
          </div>
          <div class="chart">
            <v-chart :options="currentAssets"
                     style="width:48%;height: 300px;"></v-chart>
            <img class="Arrow"
                 src="@/assets/images/wpsp/Customer-view/箭头右.png"
                 alt="">
            <v-chart :options="proposalAssets"
                     style="width:48%;height: 300px;"></v-chart>
          </div>
          <div class="compare">
            <div>
              <div class="compare-left">
                <span class="circular"
                      style="background: rgba(30, 136, 255, 0.8);"></span>
                <span class="text">固收类</span>
              </div>
              <span class="Proportion">{{assetStructureList.gsRatio}}%</span>
              <i class="el-icon-right"></i>
              <span class="Proportion">20%</span>
              <span class="disparity"
                    v-if="assetStructureList.gsRatio-20>0">
                <i class="el-icon-bottom">{{assetStructureList.gsRatio-20}}%</i>
              </span>
              <span class="disparityTwo"
                    v-else>
                <i class="el-icon-top">{{assetStructureList.gsRatio-20}}%</i>
              </span>
            </div>
            <div>
              <div class="compare-left">
                <span class="circular"
                      style="background: rgba(52,200,139,1);"></span>
                <span class="text">权益类</span>
              </div>
              <span class="Proportion">{{assetStructureList.qyRatio}}%</span>
              <i class="el-icon-right"></i>
              <span class="Proportion">20%</span>
              <span class="disparity"
                    v-if="assetStructureList.qyRatio-20>0">
                <i class="el-icon-bottom">{{assetStructureList.qyRatio-20}}%</i>
              </span>
              <span class="disparityTwo"
                    v-else>
                <i class="el-icon-top">{{20-assetStructureList.qyRatio}}%</i>
              </span>
            </div>
            <div>
              <div class="compare-left">
                <span class="circular"
                      style="background: rgba(165,168,172,1);"></span>
                <span class="text">货币类</span>
              </div>
              <span class="Proportion">{{assetStructureList.hbRatio}}%</span>
              <i class="el-icon-right"></i>
              <span class="Proportion">15%</span>
              <span class="disparity"
                    v-if="assetStructureList.hbRatio-15>0">
                <i class="el-icon-bottom">{{assetStructureList.hbRatio-15}}%</i>
              </span>
              <span class="disparityTwo"
                    v-else>
                <i class="el-icon-top">{{15-assetStructureList.hbRatio}}%</i>
              </span>
            </div>
            <div>
              <div class="compare-left">
                <span class="circular"
                      style="background:rgba(250,183,72,1);"></span>
                <span class="text">商品类</span>
              </div>
              <span class="Proportion">{{assetStructureList.spRatio}}%</span>
              <i class="el-icon-right"></i>
              <span class="Proportion">45%</span>
              <span class="disparity"
                    v-if="assetStructureList.spRatio-45>0">
                <i class="el-icon-bottom">{{assetStructureList.spRatio-45}}%</i>
              </span>
              <span class="disparityTwo"
                    v-else>
                <i class="el-icon-top">{{45-assetStructureList.spRatio}}%</i>
              </span>
            </div>
          </div>
          <div class="chart-bottom-text">
            <div>
              <span class="background">1</span>
              <span class="Thickening">固收类</span>配置略高，推荐配置20%
            </div>
            <div>
              <span class="background">2</span>
              根据您的风险偏好与家庭成员的年龄结构，建议降低
              <span class="Thickening">权益类</span>产品的的配置，增加
              <span class="Thickening">固定收益类</span> 产品的配置。
            </div>
            <div>
              <span class="background">3</span>
              根据您的风险偏好与家庭成员的年龄结构，建议降低
              <span class="Thickening">权益类</span>产品的的配置，增加
              <span class="Thickening">固定收益类</span> 产品的配置。
            </div>
          </div>
        </div>
        <div class="bottom-right">
          <span class="text">推荐产品</span>
          <div class="Solid-recovery"
               style="margin-top: 15px;">
            <div class="background"
                 style="background: rgba(241, 247, 255, 1);">固收类(20%)</div>
            <div class="product-bottom">
              <div style="height: 90px;">
                <div>
                  <p class="product-type"
                     style="background: rgba(241, 247, 255, 1);">银行理财（10%）</p>
                  <p>日日聚财A19903</p>
                </div>
                <div>
                  <p class="product-content">业绩比较基准</p>
                  <p class="color">3.56%</p>
                </div>
                <div>
                  <p class="product-content">起投金额</p>
                  <p>10,000元</p>
                </div>
                <div>
                  <p class="product-content">建议购买金额</p>
                  <p>10,000元</p>
                </div>
              </div>
            </div>
          </div>
          <div class="Equity">
            <div class="background"
                 style="background:rgba(2,187,111,0.1);">权益类（20%）</div>
            <div class="product-bottom">
              <div style="height: 90px;">
                <div>
                  <p class="product-type"
                     style="background:rgba(2,187,111,0.1);">混合型基金（20%）</p>
                  <p>日日聚财A19903</p>
                </div>
                <div>
                  <p class="product-content">近一月涨幅</p>
                  <p class="color">3.56%</p>
                </div>
                <div>
                  <p class="product-content">单位净值</p>
                  <p>10,000元</p>
                </div>
                <div>
                  <p class="product-content">建议购买金额</p>
                  <p>10,000元</p>
                </div>
              </div>
            </div>
          </div>
          <div class="Solid-recovery">
            <div class="background"
                 style="background:rgba(245,247,250,1);">货币类（15%）</div>
            <div class="product-bottom">
              <div style="height: 90px;">
                <div>
                  <p class="product-type"
                     style="background:rgba(245,247,250,1);">银行理财（10%）</p>
                  <p>日日聚财A19903</p>
                </div>
                <div>
                  <p class="product-content">业绩比较基准</p>
                  <p class="color">3.56%</p>
                </div>
                <div>
                  <p class="product-content">起投金额</p>
                  <p>10,000元</p>
                </div>
                <div>
                  <p class="product-content">建议购买金额</p>
                  <p>10,000元</p>
                </div>
              </div>
            </div>
          </div>
          <div class="Solid-recovery">
            <div class="background"
                 style="background:rgba(250,166,28,0.1);">商品类（45%）</div>
            <div class="product-bottom">
              <div style="height: 90px;">
                <div>
                  <p class="product-type"
                     style="background:rgba(250,166,28,0.1);">黄金ETF联结基金（45%）</p>
                  <p>日日聚财A19903</p>
                </div>
                <div>
                  <p class="product-content">业绩比较基准</p>
                  <p class="color">3.56%</p>
                </div>
                <div>
                  <p class="product-content">起投金额</p>
                  <p>10,000元</p>
                </div>
                <div>
                  <p class="product-content">建议购买金额</p>
                  <p>10,000元</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 保险保障 -->
    <div class="Insurance-protection">
      <div class="Insurance-protection-top">
        <span class="top-left">保险保障</span>
        <el-button type="text"
                   icon="el-icon-edit-outline">完善保险信息</el-button>
      </div>
      <div class="bottom">
        <div class="Relation-diagram">
          <!-- 父母 -->
          <div class="parent">
            <!-- 本人父母 -->
            <div class="oneself">
              <div class="Head-portrait">
                <div>
                  <el-avatar :src="require('@/assets/images/wpsp/Customer-view/oldman.png')">
                  </el-avatar>
                  <img class="img"
                       src="@/assets/images/wpsp/Customer-view/保险业务-绿.png"
                       alt="">
                </div>
                <div>父亲-{{relationshipChart.oneself.father.name}}
                  ({{relationshipChart.oneself.father.age}})</div>
              </div>
              <div class="Head-portrait">
                <div>
                  <el-avatar :src="require('@/assets/images/wpsp/Customer-view/oldwoman.png')">
                  </el-avatar>
                  <img class="img"
                       src="@/assets/images/wpsp/Customer-view/保险业务-绿.png"
                       alt="">
                </div>
                <div>母亲-{{relationshipChart.oneself.mother.name}}
                  ({{relationshipChart.oneself.mother.age}})</div>
              </div>
            </div>
            <!-- 配偶父母 -->
            <div class="spouse">
              <div class="Head-portrait">
                <div>
                  <el-avatar v-if="relationshipChart.spouse.father.name!==''"
                             :src="require('@/assets/images/wpsp/Customer-view/oldman.png')">
                  </el-avatar>
                  <el-avatar v-else>
                    +父亲
                  </el-avatar>
                  <img v-if="relationshipChart.spouse.father.name!==''"
                       class="img"
                       src="@/assets/images/wpsp/Customer-view/保险业务-绿.png"
                       alt="">
                </div>
                <div v-if="relationshipChart.spouse.father.name!==''">
                  配偶父亲-{{relationshipChart.spouse.father.name}}
                  ({{relationshipChart.spouse.father.age}})</div>
                <div>配偶父亲</div>
              </div>
              <div class="Head-portrait">
                <div>
                  <el-avatar v-if="relationshipChart.spouse.mother.name!==''"
                             :src="require('@/assets/images/wpsp/Customer-view/oldwoman.png')">
                  </el-avatar>
                  <el-avatar v-else>
                    +母亲
                  </el-avatar>
                  <img v-if="relationshipChart.spouse.mother.name!==''"
                       class="img"
                       src="@/assets/images/wpsp/Customer-view/保险业务-绿.png"
                       alt="">
                </div>
                <div v-if="relationshipChart.spouse.mother.name!==''">
                  配偶母亲-{{relationshipChart.spouse.mother.name}}
                  ({{relationshipChart.spouse.mother.age}})</div>
                <div v-else>配偶母亲</div>
              </div>
            </div>
          </div>
          <div class="line">
            <!-- 本人与父母线段 -->
            <div class="oneself-line">
              <span></span>
            </div>
            <!-- 配偶与父母线段 -->
            <div class="spouse-line">
              <span></span>
            </div>
          </div>
          <!-- 本人配偶 -->
          <div class="oneself-spouse">
            <div class="oneself">
              <div class="Head-portrait">
                <div>
                  <el-avatar v-if="relationshipChart.oneself.gender==='1'"
                             :src="require('@/assets/images/wpsp/Customer-view/man.png')">
                  </el-avatar>
                  <el-avatar v-else
                             :src="require('@/assets/images/wpsp/Customer-view/woman.png')">
                  </el-avatar>
                  <img class="img"
                       src="@/assets/images/wpsp/Customer-view/保险业务-绿.png"
                       alt="">
                </div>
                <div>本人-{{relationshipChart.oneself.name}}({{relationshipChart.oneself.age}})</div>
              </div>
            </div>
            <div class="spouse">
              <div class="Head-portrait">
                <div v-if="relationshipChart.spouse.name!==''">
                  <el-avatar v-if="relationshipChart.oneself.gender!=='1'"
                             :src="require('@/assets/images/wpsp/Customer-view/man.png')">
                  </el-avatar>
                  <el-avatar v-else
                             :src="require('@/assets/images/wpsp/Customer-view/woman.png')">
                  </el-avatar>
                  <img class="img"
                       src="@/assets/images/wpsp/Customer-view/保险业务-绿.png"
                       alt="">
                </div>
                <el-avatar v-else>
                  +配偶
                </el-avatar>
                <div v-if="relationshipChart.spouse.name!==''">
                  配偶-{{relationshipChart.spouse.name}}({{relationshipChart.spouse.age}})</div>
                <div v-else>配偶</div>
              </div>
            </div>
          </div>
          <!-- 本人与配偶之间的线段 -->
          <div class="line">
            <div class="oneselfAndSpouse-line">
              <span></span>
            </div>
          </div>
          <!-- 子女线段 -->
          <div class="line"
               v-if="relationshipChart.childrenList.length!==0">
            <!-- 本人与父母线段 -->
            <div :class="relationshipChart.childrenList.length===1?'children-line-one'
          :relationshipChart.childrenList.length===2?'children-line-Two'
          :relationshipChart.childrenList.length===3?'children-line-Three'
          :relationshipChart.childrenList.length===4?'children-line-Four':'children-line-Five'">
              <div v-if="relationshipChart.childrenList.length===1">
              </div>
              <div v-if="relationshipChart.childrenList.length===2">
                <span></span>
              </div>
              <div v-if="relationshipChart.childrenList.length===3">
                <span class="line-left"></span>
                <span class="line-right"></span>
              </div>
              <div v-if="relationshipChart.childrenList.length===4">
                <span class="line-left"></span>
                <span></span>
                <span class="line-right"></span>
              </div>
              <div v-if="relationshipChart.childrenList.length===5">
                <span class="line-left"></span>
                <span></span>
                <span class="line-right"></span>
              </div>
            </div>
          </div>
          <!-- 子女 -->
          <div class="children">
            <div v-for="(v,i) in relationshipChart.childrenList"
                 :key="i"
                 class="Head-portrait">
              <div>
                <el-avatar v-if="v.gender==='1'"
                           :src="require('@/assets/images/wpsp/Customer-view/boy.png')">
                </el-avatar>
                <el-avatar v-else
                           :src="require('@/assets/images/wpsp/Customer-view/girl.png')">
                </el-avatar>
                <img class="img"
                     src="@/assets/images/wpsp/Customer-view/保险业务-绿.png"
                     alt="">
              </div>
              <div>子女-{{v.name}}一({{v.age}})</div>
            </div>
            <div v-if="relationshipChart.childrenList.length!==5"
                 class="add-children">
              <div>
                <el-avatar>+子女</el-avatar>
              </div>
              <div>子女{{relationshipChart.childrenList.length+1}}</div>
            </div>
          </div>
        </div>
        <div class="Present-situation">
          <div class="top">现状</div>
          <div>
            <p>• 当前家庭共有<span>5位</span>成员，其中2位已配置了完备的保险产品，仍有<span>3位缺失保险保障。</span></p>
            <p>• 社保是基本社会福利，涵盖了基本的养老、医疗、失业、工伤和生育保障，建议尽 可能优先补充。</p>
            <p>• 适当配置商业保险，来抵御一些重大风险，在不幸发生时可以提供有力的现金支援 避免整个家庭陷入财务危机。</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 配置建议 -->
    <div class="proposal">
      <div class="proposal-top">
        <span class="top-left">资产检视</span>
        <el-button type="text">查看详情</el-button>
      </div>
      <div class="proposal-table">
        <el-table :data="proposalData"
                  stripe
                  style="width: 100%"
                  :header-cell-style="{background:'#EDF6FF'}">
          <el-table-column label="被投保人"
                           align="center"
                           header-align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="健康关怀"
                           align="center"
                           header-align="center">
            <template slot-scope="scope">
              <div class="circular"
                   v-if="scope.row.Healthy"></div>
            </template>
          </el-table-column>
          <el-table-column label="抵御风险"
                           align="center"
                           header-align="center">
            <template slot-scope="scope">
              <div class="circular"
                   v-if="scope.row.ResistRisks"></div>
            </template>
          </el-table-column>
          <el-table-column label="保家护航"
                           align="center"
                           header-align="center">
            <template slot-scope="scope">
              <div class="circular"
                   v-if="scope.row.HomeEscort"></div>
            </template>
          </el-table-column>
          <el-table-column label="终生保障"
                           align="center"
                           header-align="center">
            <template slot-scope="scope">
              <div class="circular"
                   v-if="scope.row.LifetimeGuarantee"></div>
            </template>
          </el-table-column>
          <el-table-column label="保障增值"
                           align="center"
                           header-align="center">
            <template slot-scope="scope">
              <div class="circular"
                   v-if="scope.row.increment"></div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="Tips">
        Tips：配置建议主要针对未完善保险保障的家庭成员，“<span></span>”表示建议配置。
      </div>
    </div>
  </div>
</template>
<script>
import financialInformationEdit from '../financialInformationEdit.vue';
import IncomeAndExpenditureEdit from '../IncomeAndExpenditureEdit.vue';

export default {
  components: {
    financialInformationEdit,
    IncomeAndExpenditureEdit,
  },
  filters: {},
  data() {
    return {
      // 客户信息
      customerData: {},
      customerDataRow: {},
      // 家庭成员
      memberOfFamily: {},
      dialogVisible: false, // 完善财务信息弹框
      // 指标分析数据
      indexAnalysisList: {
        expendStructure: {
          expendStructure1: '',
          expendStructure0: '',
          incomeStructMark: '1',
        },
        debtStructure: {
          debtStructure0: '',
          debtStructure1: '',
          incomeStructMark: '1',
        },
        financeFlowStructure: {
          financeFlowStructure1: '',
          financeFlowStructure0: '',
          incomeStructMark: '1',
        },
        incomeStructure: {
          incomeStruct0: '',
          incomeStruct1: '',
          incomeStructMark: '1',
        },
      },
      FamilyIncome: {},
      // 家庭收入支出数据
      incomeExpenditure: {},
      // 收入饼图数据
      incomeOptions: {},
      // 支出饼图数据
      expenditureOptions: {},
      // 当前资产结构饼图数据
      currentAssets: {},
      // 建议资产数据
      assetStructureList: {},
      // 建议资产结构饼图数据
      proposalAssets: {},
      activeName: 'Finance',
      activeNameTwo: 'oneself',
      // 负债编辑开关
      LiabilitiesEditShow: true,
      // 关系图数据
      relationshipChart: {
        oneself: {
          name: '张三',
          age: '40',
          gender: '1',
          father: {
            name: '张一',
            age: '75',
          },
          mother: {
            name: '李一',
            age: '75',
          },
        },
        spouse: {
          name: '',
          age: '',
          gender: '',
          father: {
            name: '',
            age: '',
          },
          mother: {
            name: '',
            age: '',
          },
        },
        childrenList: [
          {
            name: '李四',
            age: '12',
            gender: '1',
          },
          {
            name: '李四',
            age: '12',
            gender: '1',
          },
          {
            name: '李四',
            age: '12',
            gender: '1',
          },
          {
            name: '李四',
            age: '12',
            gender: '1',
          },
        ],
      },
      // 配置建议表格数据
      proposalData: [
        {
          name: '本人（张三）',
          Healthy: true,
          ResistRisks: false,
          HomeEscort: true,
          LifetimeGuarantee: false,
          increment: false,
        },
        {
          name: '配偶（王五）',
          Healthy: true,
          ResistRisks: false,
          HomeEscort: true,
          LifetimeGuarantee: false,
          increment: false,
        },
        {
          name: '子女（张一）',
          Healthy: true,
          ResistRisks: false,
          HomeEscort: true,
          LifetimeGuarantee: false,
          increment: false,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    const parames = {
      data: {
        // cis: '300000000022',
        cis: JSON.parse(sessionStorage.getItem('customer')).cis,
      },
    };
    this.getCustInfo();
    this.AssetsInformation(parames);
    this.indexAnalysis(parames);
    this.assetsRatio(parames);
    this.proposalAssets = {
      title: {
        text: '建议资产结构',
        left: 'center',
      },
      tooltip: {
        trigger: 'item',
        formatter: '{b}: {d}%',
      },
      color: ['#1E88FF', '#34C88B', '#A5A8AC', '#FAB748'],
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['50%', '80%'],
          label: {
            show: false,
          },
          data: [
            { value: 20, name: '固收类' },
            { value: 20, name: '权益类' },
            { value: 15, name: '货币类' },
            { value: 45, name: '商品类' },
          ],
        },
      ],
    };
  },
  methods: {
    // 获取基本客户信息
    getCustInfo() {
      console.log(JSON.parse(sessionStorage.getItem('customer')));
      const parames = {
        data: {
          id: JSON.parse(sessionStorage.getItem('customer')).id,
          token: JSON.parse(sessionStorage.getItem('userToken')),
          userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.getCustInfo, parames).then((res) => {
        this.customerData = res;
        this.customerDataRow = JSON.parse(sessionStorage.getItem('customer'));
        console.log(this.customerDataRow);
      });
      this.$_post(this.$API.list_cust_supple, {
        data: {
          cis: JSON.parse(sessionStorage.getItem('customer')).cis,
          uId: JSON.parse(sessionStorage.getItem('customer')).userId,
        },
      }).then((res) => {
        this.memberOfFamily = res.data.allCustSupple;
      });
    },

    // 家庭资产情况查询
    AssetsInformation(parames) {
      this.$_post(this.$API.AssetsInformation, parames).then((res) => {
        this.incomePieChart(res.data.income);
        this.expenditurePieChart(res.data.expend);
        this.FamilyIncome = res.data.total;
        this.incomeExpenditure = res.data;
      });
    },
    // 指标查询
    indexAnalysis(parames) {
      this.$_post(this.$API.indexAnalysis, parames).then((res) => {
        console.log(res);
        this.indexAnalysisList = res.data;
      });
    },
    // 收入饼图赋值方法
    incomePieChart(data) {
      this.incomeOptions = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)',
        },
        color: ['#F0C93A', '#2DC6F7', '#02BB6F'],
        legend: {
          orient: 'horizontal',
          bottom: '1%',
          icon: 'circle',
          data: ['工资收入', '投资收益', '其他收入'],
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['30%', '50%'],
            label: {
              show: true,
              formatter: '收入',
              position: 'center',
              color: '#303133',
              fontSize: 14,
              normal: {
                show: true,
                formatter: '{b}\n{d}%',
              },
            },
            data: [
              { value: data.salaryIncome, name: '工资收入' },
              { value: data.invest, name: '投资收益' },
              { value: data.otherIncome, name: '其他收入' },
            ],
          },
        ],
      };
    },
    // 支出饼图赋值方法
    expenditurePieChart(data) {
      this.expenditureOptions = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)',
        },
        color: ['#9EA1A5', '#F26D6D', '#D898E6'],
        legend: {
          orient: 'horizontal',
          bottom: '1%',
          icon: 'circle',
          data: ['日常支出', '贷款及利息', '其他'],
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['30%', '50%'],
            label: {
              show: true,
              formatter: '支出',
              position: 'center',
              color: '#303133',
              fontSize: 14,
              normal: {
                show: true,
                formatter: '{b}\n{d}%',
              },
            },
            data: [
              { value: data.dailyExpend, name: '日常支出' },
              { value: data.loanInterestExpend, name: '贷款及利息' },
              { value: data.otherExpend, name: '其他' },
            ],
          },
        ],
      };
    },
    // 当前资产结构占比
    assetsRatio(parames) {
      this.$_post(this.$API.AssetsRatio, parames).then((res) => {
        console.log(res, '当前资产结构占比');
        this.assetStructurePieChart(res.data);
        this.assetStructureList = res.data;
      });
    },
    // 当前资产结构饼图赋值
    assetStructurePieChart(data) {
      this.currentAssets = {
        title: {
          text: '当前资产结构',
          left: 'center',
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {d}%',
        },
        color: ['#1E88FF', '#34C88B', '#A5A8AC', '#FAB748'],
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['50%', '80%'],
            label: {
              show: false,
            },
            data: [
              { value: data.gsRatio, name: '固收类' },
              { value: data.qyRatio, name: '权益类' },
              { value: data.hbRatio, name: '货币类' },
              { value: data.spRatio, name: '商品类' },
            ],
          },
        ],
      };
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    financialInformationPreservation() {
      if (this.activeNameTwo === 'oneself') {
        this.$refs.LiabilitiesOne.modify();
      } else if (this.activeNameTwo === 'spouse') {
        this.$refs.LiabilitiesTwo.modify();
      } else {
        this.$refs.LiabilitiesThree.modify();
      }
    },
    incomeAndExpenditurePreservation() {
      this.dialogVisible = false;
      this.$refs.incomeAndExpenditure.preservation();
    },
    ModificationFailed(bool) {
      this.dialogVisible = !bool;
    },
  },
};
</script>
<style lang='scss'>
.Assets-analysis {
  .Title {
    display: flex;
    justify-content: space-between;
    > span {
      font-size: 20px;
      font-weight: 500;
    }
    button {
      width: 84px;
      height: 30px;
      padding: 6px 14px;
    }
  }
  .personal-data-one {
    padding-left: 32px;
    .oneself {
      .name {
        font-size: 24px;
        font-weight: 500;
        color: rgba(30, 136, 255, 1);
      }
      span {
        margin: 0px 12px;
      }
    }
    .member {
      span {
        font-size: 14px;
        color: rgba(96, 98, 102, 1);
      }
    }
  }
  .personal-data-two {
    padding: 0px 0px 20px 32px;
    box-shadow: 0px 3px 6px 0px rgba(192, 196, 204, 0.38);
    border-radius: 4px;
    .Telephone {
      span {
        margin: 0px 12px;
      }
    }
    .Features {
      .Label {
        span {
          display: inline-block;
          width: 73px;
          height: 24px;
          font-size: 12px;
          color: rgba(30, 136, 255, 1);
          background: rgba(237, 246, 255, 1);
          text-align: center;
          line-height: 24px;
        }
      }
    }
  }
  .financial-analysis {
    margin-top: 34px;
    .financial-analysis-top {
      display: flex;
      justify-content: space-between;
      .top-left {
        font-size: 16px;
        font-weight: 500;
        color: rgba(48, 49, 51, 1);
      }
    }
    .financial-analysis-bottom {
      display: flex;
      justify-content: space-between;
      .bottom-left {
        padding: 25px 15px;
        width: 48%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        > div {
          width: 45%;
          padding: 10px 0px;
          .text {
            padding: 10px 0px;
            margin-left: 10px;
            font-size: 14px;
            font-weight: 500;
            color: rgba(48, 49, 51, 1);
            position: relative;
            top: -3px;
          }
          div {
            padding: 14px;
            width: 100%;
            height: 55px;
            // background: rgba(245, 247, 250, 1);
            span {
              color: #f95353;
            }
          }
        }
      }
      .bottom-right {
        width: 48%;
        padding: 25px 15px;
        .text {
          font-size: 14px;
          color: rgba(96, 98, 102, 1);
          span {
            color: #303133;
          }
        }
        .chart {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
  .perfectFinance {
    height: 700px;
    overflow: auto;
    .Finance {
      .top {
        display: flex;
        justify-content: space-between;
        .Title {
          font-size: 16px;
          color: rgba(48, 49, 51, 1);
        }
        .Tips {
          display: inline-block;
          height: 16px;
          font-size: 16px;
          color: #1e88ff;
          text-align: center;
          margin: 29px 13px 35px;
        }
      }
      .bottom {
        .el-tabs__item {
          width: 100px;
          height: 32px;
          text-align: center;
          line-height: 32px;
        }
        .el-tabs {
          width: 100%;
        }
      }
    }
    .income {
      margin-top: 40px;
      .top {
        display: flex;
        justify-content: space-between;
        .Title {
          font-size: 16px;
          color: rgba(48, 49, 51, 1);
        }
        .Tips {
          display: inline-block;
          width: 70px;
          height: 24px;
          font-size: 12px;
          background: rgba(250, 166, 28, 0.2);
          color: #faa61c;
          border-radius: 12px;
          text-align: center;
          line-height: 24px;
          margin: 0px 13px;
        }
      }
    }
    .Insurance {
      margin-top: 40px;
      .top {
        display: flex;
        justify-content: space-between;
        .Title {
          font-size: 16px;
          color: rgba(48, 49, 51, 1);
        }
      }
    }
  }
  .assets-inspection {
    .assets-inspection-top {
      display: flex;
      justify-content: space-between;
      .el-button--text {
        margin-left: 20px;
      }
      .top-left {
        font-size: 16px;
        font-weight: 500;
        color: rgba(48, 49, 51, 1);
      }
    }
    .assets-inspection-bottom {
      padding: 23px 26px 17px 38px;
      display: flex;
      justify-content: space-between;
      .text {
        font-size: 14px;
        font-weight: 500;
      }
      .bottom-left {
        width: 48%;
        .risk-level {
          margin-top: 30px;
          width: 100%;
          height: 25px;
          background: linear-gradient(
            90deg,
            rgba(53, 201, 140, 1) 0%,
            rgba(251, 184, 73, 1) 49%,
            rgba(242, 109, 109, 1) 100%
          );
          display: flex;
          justify-content: space-between;
          span {
            position: relative;
            display: inline-block;
            width: 25%;
            text-align: center;
            line-height: 25px;
            color: rgba(255, 255, 255, 1);
            border-right: 1px solid rgba(255, 255, 255, 1);
            img {
              position: absolute;
              top: -20px;
              left: 46%;
            }
          }
        }
        .explain-text {
          margin-top: 10px;
          span {
            font-weight: 600;
          }
        }
        .chart {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .Arrow {
            width: 28px;
            height: 28px;
          }
        }
        .compare {
          padding-right: 50px;
          > div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 10px 0px;
            .compare-left {
              .circular {
                display: inline-block;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                margin-right: 12px;
              }
              .text {
                color: rgba(96, 98, 102, 1);
              }
            }
            .Proportion {
              display: inline-block;
              width: 34px;
              font-size: 16px;
              font-weight: 500;
              color: rgba(48, 49, 51, 1);
            }
            .disparity {
              width: 65px;
              color: #02bb6f;
            }
            .disparityTwo {
              width: 65px;
              color: #f95353;
            }
          }
        }
        .chart-bottom-text {
          > div {
            padding: 10px 0px;
          }
          .background {
            display: inline-block;
            width: 24px;
            height: 24px;
            background: rgba(30, 136, 255, 0.2);
            font-size: 14px;
            font-weight: normal;
            color: rgba(30, 136, 255, 1);
            font-style: italic;
            text-align: center;
            line-height: 24px;
            margin-right: 10px;
          }
          .Thickening {
            font-weight: 600;
          }
        }
      }
      .bottom-right {
        width: 48%;
        .Solid-recovery,
        .Equity {
          margin: 0px;
          .background {
            padding-left: 17px;
            line-height: 40px;
            height: 40px;
            border: 1px solid rgba(238, 238, 238, 1);
            border-bottom: 0px;
          }
          .product-bottom {
            border: 1px solid rgba(238, 238, 238, 1);
            border-bottom: 0px;
            > div {
              padding: 0px 17px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-bottom: 1px solid rgba(238, 238, 238, 1);
              .product-type {
                margin-bottom: 10px;
                text-align: center;
                line-height: 22px;
                display: inline-block;
                width: 145px;
                height: 22px;
                font-size: 12px;
                color: rgba(96, 98, 102, 1);
              }
              .color {
                color: rgba(249, 83, 83, 1);
              }
              .product-content {
                margin-bottom: 10px;
                font-size: 12px;
                color: rgba(144, 147, 153, 1);
              }
            }
          }
        }
      }
    }
  }
  .Insurance-protection {
    margin-top: 50px;
    .Insurance-protection-top {
      display: flex;
      justify-content: space-between;
      .top-left {
        font-size: 16px;
        font-weight: 500;
        color: rgba(48, 49, 51, 1);
      }
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      margin-top: 14px;
      .Relation-diagram {
        // width: 557px;
        height: 285px;
        background: rgba(237, 246, 255, 1);
        // 父母
        .parent {
          margin: 10px 0px;
          font-size: 12px;
          display: flex;
          justify-content: space-around;
          .oneself {
            width: 260px;
            display: flex;
            justify-content: space-around;
            .Head-portrait {
              position: relative;
              margin: 0px 10px;
              width: 110px;
              text-align: center;
              .el-avatar--circle {
                font-size: 12px;
                color: rgba(30, 136, 255, 1);
                background: #ffffff;
                border: 1px solid rgba(30, 136, 255, 1);
              }
              .img {
                position: absolute;
                top: 20px;
                left: 60px;
              }
            }
          }
          .spouse {
            width: 260px;
            display: flex;
            justify-content: space-around;
            .Head-portrait {
              width: 110px;
              text-align: center;
              position: relative;
              .el-avatar--circle {
                font-size: 12px;
                color: rgba(30, 136, 255, 1);
                background: #ffffff;
                border: 1px solid rgba(30, 136, 255, 1);
              }
              .img {
                position: absolute;
                top: 20px;
                left: 60px;
              }
            }
          }
        }
        // 本人与配偶
        .oneself-spouse {
          margin: 10px 0px;
          font-size: 12px;
          display: flex;
          justify-content: space-around;
          .Head-portrait {
            margin: 0px 10px;
            width: 110px;
            text-align: center;
            position: relative;
            .el-avatar--circle {
              font-size: 12px;
              color: rgba(30, 136, 255, 1);
              background: #ffffff;
              border: 1px solid rgba(30, 136, 255, 1);
            }
            .img {
              position: absolute;
              top: 20px;
              left: 60px;
            }
          }
        }
        // 子女
        .children {
          margin: 10px 0px;
          font-size: 12px;
          display: flex;
          justify-content: space-around;
          .Head-portrait {
            margin: 0px 10px;
            width: 110px;
            text-align: center;
            position: relative;
            .el-avatar--circle {
              font-size: 12px;
              color: rgba(30, 136, 255, 1);
              background: #ffffff;
              border: 1px solid rgba(30, 136, 255, 1);
            }
            .img {
              position: absolute;
              top: 20px;
              left: 60px;
            }
          }
          .add-children {
            margin: 0px 10px;
            width: 110px;
            text-align: center;
            .el-avatar--circle {
              font-size: 12px;
              color: rgba(30, 136, 255, 1);
              background: #ffffff;
              border: 1px solid rgba(30, 136, 255, 1);
            }
          }
        }
        // 线段
        .line {
          display: flex;
          justify-content: space-around;
          .oneself-line {
            width: 130px;
            height: 6px;
            border: 1px solid #606266;
            border-top: 0px;
            text-align: center;
            span {
              display: inline-block;
              height: 8px;
              border-left: 1px solid #606266;
            }
          }
          .spouse-line {
            width: 130px;
            height: 6px;
            border: 1px solid #606266;
            border-top: 0px;
            text-align: center;
            span {
              display: inline-block;
              height: 8px;
              border-left: 1px solid #606266;
            }
          }
          .oneselfAndSpouse-line {
            width: 280px;
            height: 6px;
            border: 1px solid #606266;
            border-top: 0px;
            text-align: center;
            span {
              display: inline-block;
              height: 8px;
              border-left: 1px solid #606266;
            }
          }
          .children-line-one {
            width: 280px;
            height: 6px;
            border: 1px solid #606266;
            border-bottom: 0px;
            text-align: center;
            position: relative;
            top: 8px;
            span {
              display: inline-block;
              height: 8px;
              border-left: 1px solid #606266;
              position: relative;
              top: -8px;
            }
            .line-left {
              left: -111px;
            }
            .line-right {
              left: 111px;
            }
          }
          .children-line-Two {
            width: 371px;
            height: 6px;
            border: 1px solid #606266;
            border-bottom: 0px;
            text-align: center;
            position: relative;
            top: 8px;
            span {
              display: inline-block;
              height: 8px;
              border-left: 1px solid #606266;
              position: relative;
              top: -8px;
            }
            .line-left {
              left: -111px;
            }
            .line-right {
              left: 111px;
            }
          }
          .children-line-Three {
            width: 416px;
            height: 6px;
            border: 1px solid #606266;
            border-bottom: 0px;
            text-align: center;
            position: relative;
            top: 8px;
            span {
              display: inline-block;
              height: 8px;
              border-left: 1px solid #606266;
              position: relative;
              top: -8px;
            }
            .line-left {
              left: -69px;
            }
            .line-right {
              left: 69px;
            }
          }
          .children-line-Four {
            width: 445px;
            height: 6px;
            border: 1px solid #606266;
            border-bottom: 0px;
            text-align: center;
            position: relative;
            top: 8px;
            span {
              display: inline-block;
              height: 8px;
              border-left: 1px solid #606266;
              position: relative;
              top: -8px;
            }
            .line-left {
              left: -111px;
            }
            .line-right {
              left: 111px;
            }
          }
          .children-line-Five {
            width: 445px;
            height: 6px;
            border: 1px solid #606266;
            border-bottom: 0px;
            text-align: center;
            position: relative;
            top: 8px;
            span {
              display: inline-block;
              height: 8px;
              border-left: 1px solid #606266;
              position: relative;
              top: -8px;
            }
            .line-left {
              left: -111px;
            }
            .line-right {
              left: 111px;
            }
          }
        }
      }
      .Present-situation {
        width: 48%;
        .top {
          font-weight: 500;
          color: rgba(48, 49, 51, 1);
          padding-bottom: 10px;
        }
        p {
          padding: 10px 0px;
        }
      }
    }
  }
  .proposal {
    margin-top: 50px;
    .proposal-top {
      display: flex;
      justify-content: space-between;
      .top-left {
        font-size: 16px;
        font-weight: 500;
        color: rgba(48, 49, 51, 1);
      }
    }
    .proposal-table {
      .el-table__header-wrapper {
        background: rgba(237, 246, 255, 1);
      }
      .cell {
        display: flex;
        justify-content: center;
      }
      .circular {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: 1px solid rgba(153, 153, 153, 1);
      }
    }
    .Tips {
      margin: 10px 0px;
      color: rgba(144, 147, 153, 1);
      span {
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: 1px solid rgba(153, 153, 153, 1);
      }
    }
  }
}
</style>
